import React, { createContext } from 'react'
import { useSocket } from 'src/hooks/useSocket'

export const SocketContext = createContext()

export const SocketProvider = ({ children }) => {
  const { socket } = useSocket(`https://${process.env.REACT_APP_HOST}`)

  return <SocketContext.Provider value={{ socket }}>{children}</SocketContext.Provider>
}